module.exports = __webpack_public_path__ + "img/28_18.7a8eb40f.png";